import { apiGet, apiGetBlob } from '../client';
import type { Telemetry } from '@/types/api';

export function listTelemetry(deviceId: number, limit = 100): Promise<Telemetry[]> {
  return apiGet<Telemetry[]>(`/telemetry/${deviceId}`, { query: { limit } });
}

export interface ExportRange {
  start_time?: string;
  end_time?: string;
  limit?: number;
}

/**
 * Streams CSV. Note the backend answers 404 when the requested window contains no
 * rows, rather than returning an empty file — callers must treat that as "no data
 * in this range", not as a missing device.
 */
export function exportTelemetryCsv(deviceId: number, range: ExportRange = {}): Promise<Blob> {
  return apiGetBlob(`/telemetry/export-csv/${deviceId}`, {
    query: {
      start_time: range.start_time,
      end_time: range.end_time,
      limit: range.limit ?? 10000,
    },
  });
}
